/* Staten Tools: Request custom engraving launcher (guarded by backend readiness) */
(function () {
  'use strict';
  if (window.__stEngravingRequests) return; window.__stEngravingRequests = true;
  var HOST = 'https://merchant-tools-suite.replit.app';
  var READY = HOST + '/api/engraving-requests/ready', PAGE = HOST + '/api/engraving-request';
  var dlg, back;

  function open(e) {
    if (e) e.preventDefault();
    back = document.activeElement;
    if (!dlg) build();
    dlg.hidden = false; document.documentElement.classList.add('st-er-lock');
    var f = dlg.querySelector('iframe'); if (!f.src) f.src = PAGE;
    dlg.querySelector('.st-er-close').focus();
  }
  function close() {
    if (!dlg || dlg.hidden) return;
    dlg.hidden = true; document.documentElement.classList.remove('st-er-lock');
    if (back && back.focus) back.focus();
  }
  function build() {
    dlg = document.createElement('div');
    dlg.className = 'st-er-overlay'; dlg.hidden = true;
    dlg.innerHTML = '<div class="st-er-dialog" role="dialog" aria-modal="true" aria-labelledby="st-er-title"><div class="st-er-bar"><span id="st-er-title">Request custom engraving</span><button type="button" class="st-er-close" aria-label="Close engraving request">&times;</button></div><iframe title="Staten Tools custom engraving request form" referrerpolicy="no-referrer" allow="clipboard-write"></iframe></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('.st-er-close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    document.addEventListener('keydown', function (e) {
      if (dlg.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') { var c = dlg.querySelector('.st-er-close'), f = dlg.querySelector('iframe'); if (document.activeElement === c && !e.shiftKey) { e.preventDefault(); f.focus(); } else if (document.activeElement !== c && e.shiftKey) { e.preventDefault(); c.focus(); } }
    });
  }
  function btn(cls, text) { var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.textContent = text; b.addEventListener('click', open); return b; }

  function mount() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && /product/.test(document.body.className) && !document.querySelector('.st-er-inline')) {
      var w = document.createElement('div'); w.className = 'st-er-inline';
      w.appendChild(btn('st-er-btn', 'Request custom engraving'));
      var s = document.createElement('p'); s.className = 'st-er-note'; s.textContent = 'Any tool, any text. Quoted by our engravers before anything is charged.';
      w.appendChild(s);
      form.parentNode.insertBefore(w, form.nextSibling);
    }
    var foot = document.getElementById('t4s-footer');
    if (foot && !document.querySelector('.st-er-foot')) {
      var d = document.createElement('div'); d.className = 'st-er-foot';
      d.appendChild(btn('st-er-link', 'Request custom engraving on any product'));
      foot.insertBefore(d, foot.firstChild);
    }
  }

  function init() {
    if (!window.fetch) return;
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
    fetch(READY, { mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { clearTimeout(t); if (d && d.ready === true) mount(); })
      .catch(function () { clearTimeout(t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
